import { render, staticRenderFns } from "./TemplateDashboardSlotSelector.vue?vue&type=template&id=04614226"
import script from "./TemplateDashboardSlotSelector.vue?vue&type=script&lang=js"
export * from "./TemplateDashboardSlotSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports